import React from "react";
import "./style.scss";
import { Fade, Slide } from "@mui/material";
import cancel from "../../assets/drawables/cancel.svg";
import cn from "classnames";

interface ModalProps extends React.PropsWithChildren {
  closeModal: () => void,
  isRed?: boolean
  openModal?: boolean,
  noCancel?: boolean,
  title?: string,
}
const Modal = ({
  children,
  closeModal,
  openModal = false,
  title = '',
  noCancel = false,
  isRed = false,
}: ModalProps) => {
  return (
    <Fade in={openModal}>
      <div
        onClick={(e) => e.target === e.currentTarget && closeModal()}
        className="pd-modal"
      >
        <Slide direction="up" in={openModal} mountOnEnter unmountOnExit>
          <div className="popBox2">
            <div className="top">
              <p className={cn('title', { red: isRed })}>{title}</p>
              {!noCancel && (
                <img
                  onClick={closeModal}
                  src={cancel}
                  className="cancel"
                  alt="cancel"
                />
              )}
            </div>
            <div className="modal_cover">{children}</div>
          </div>
        </Slide>
      </div>
    </Fade>
  );
};

export default Modal;
